import { ScrollContext } from "@/contexts";
import { useContext } from "react";

export const useScrollContext = () => useContext(ScrollContext);
